import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import LinkButton from 'flarum/common/components/LinkButton';

export default function addSidebarNav() {
  extend(IndexPage.prototype, 'navItems', function (items) {
    if (app.forum.attribute('support_knowledge_base_add_sidebar_nav') && app.forum.attribute('support_knowledge_base_add_sidebar_nav') !== '0') {
      items.add(
        'knowledgebase',
        <LinkButton icon="fas fa-book" href={app.route('knowledgeBase')}>
          {app.translator.trans('v17development-flarum-support.forum.knowledge_base')}
        </LinkButton>,
        15
      );
    }

    if (
      app.forum.attribute('supportTicketsEnabled') &&
      app.session.user &&
      app.forum.attribute('supportTicketsAddSidebarNav') &&
      app.forum.attribute('supportTicketsAddSidebarNav') === true
    ) {
      items.add(
        'tickets',
        <LinkButton icon="fas fa-ticket-alt" href={app.route('ticketsOverview')}>
          {app.translator.trans('v17development-flarum-support.forum.tickets.my_tickets.title')}
        </LinkButton>,
        15
      );
    }

    return items;
  });
}
